import {
  isRefundConfigurationV2Enabled,
  isReturnConditionsV2Enabled,
  isReturnReasonsV2Enabled,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { useWarehousesScope } from '@/hooks/use-warehouses-scope'

// Which settings of the group on screen are on their group-level (v2) tables, one flag per setting.
export function useReturnsAndRefundsV2() {
  const { scope } = useWarehousesScope()
  const group = scope.kind === 'none' ? undefined : scope.group
  const conditions = useFeatureFlag(isReturnConditionsV2Enabled, { group })
  const reasons = useFeatureFlag(isReturnReasonsV2Enabled, { group })
  const refunds = useFeatureFlag(isRefundConfigurationV2Enabled, { group })
  return {
    conditions: conditions.isFlagEnabled,
    reasons: reasons.isFlagEnabled,
    refunds: refunds.isFlagEnabled,
    loading:
      conditions.isFlagLoading || reasons.isFlagLoading || refunds.isFlagLoading
  }
}
